// All timeout values are in milliseconds (for example, 60000 = 60 seconds).
export const DEFAULT_API_TIMEOUT = 60000;
export const LONG_API_TIMEOUT = 300000; 

export const API_TIMEOUTS = {
  errorMessageService: DEFAULT_API_TIMEOUT,
  fileService: DEFAULT_API_TIMEOUT,
  floorplan: LONG_API_TIMEOUT,
  microsoftGraph: DEFAULT_API_TIMEOUT,
  pimService: DEFAULT_API_TIMEOUT,
  project: DEFAULT_API_TIMEOUT,
  simulation: DEFAULT_API_TIMEOUT,
  templateService: DEFAULT_API_TIMEOUT,
  userPreferences: DEFAULT_API_TIMEOUT,
};

/**
 * @description the root directory where all project files (reference-image, uvt, etc) are saved in remote file storage
 */
export const PROJECT_FILES_ROOT_CONTAINER = 'project';

/**
 * @description the relative directory where the kollmorgen .mdb files are saved in remote file storage
 *
 * IMPORTANT: do not change, or the backend will break. Check PimApi's 'DownloadAssetAndUploadToFileApi' for more details
 */
export const KM_MDB_ASSET_FILE_CONTAINER = 'km_mdb';

/**
 * @description the relative directory where uvt files are saved in remote file storage
 *
 * IMPORTANT: do not change, or the backend will break. Check PimApi's 'DownloadAssetAndUploadToFileApi' for more details
 */
export const UVT_ASSET_FILE_CONTAINER = 'uvt';

/**
 * @description the relative directory where fms_config files are saved in remote file storage
 */
export const FMS_CONFIG_CONTAINER = 'fms_config';

/**
 * @description the relative directory where order_profile files are saved in remote file storage
 */
export const ORDER_PROFILE_CONTAINER = 'order_profile';

/**
 * @description the relative directory where point cloud related files are saved in remote file storage
 */
export const POINT_CLOUD_FILES_CONTAINER = 'point_cloud';

/**
 * @description the relative directory where reference images are saved in remote file storage
 */
export const REFERENCE_IMAGE_FILE_CONTAINER = 'reference_image';
